export function sentryConfigGenerator(dsn, environment, offline, release, normalIntegrations, offlineIntegrations) {
    if (dsn && /^http.*/.exec(dsn) && environment && environment !== 'SENTRY_ENVIRONMENT' && release) {
        return {
            dsn,
            environment,
            release,
            integrations: offline === 'true' ? [...normalIntegrations, ...offlineIntegrations] : normalIntegrations,
        };
    }
    return false;
}
//# sourceMappingURL=sentryConfig.js.map